(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.glow.core'

  require('angular')
    .module(MODULE_NAME, [
      require('./glow-config'),
      require('./component')
    ])

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/glow.js